import { useState, useEffect, useCallback } from 'react';
import axios from '../../axiosConfig';
import i18n from '../../i18n';

export const useTrainerDashboard = () => {
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchDashboardData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('jwt');
            const response = await axios.get('/api/v1/trainer/dashboard', {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            setDashboardData(response.data);
        } catch (err) {
            console.error('Failed to fetch trainer dashboard data:', err);
            setError(err.message || i18n.t('dashboard:trainer.loadError'));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchDashboardData();
    }, [fetchDashboardData]);

    const refresh = useCallback(() => {
        fetchDashboardData();
    }, [fetchDashboardData]);

    return {
        dashboardData,
        loading,
        error,
        refresh,
    };
};

export default useTrainerDashboard;
